import React, { Component } from "react";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
/**
 *  Home Page Popup Modal
 */
import colors from "./colors";
import ReactHTMLParser from "react-html-parser";
class AboutModal extends Component {
  render() {
    // console.log(this.props)
    return (
      <MDBContainer>
        {/* <MDBBtn color="primary" onClick={this.toggle(14)}>MDBModal</MDBBtn> */}
        <MDBModal
          isOpen={this.props.modal}
          toggle={this.props.toggle}
          centered
          backdrop={false}
          size="lg"
        >
          <MDBModalHeader
            className="text-center"
            titleClass="w-100 font-weight-bold"
            toggle={this.props.toggle}
            style={{ background: "#3f51b5",color:"white" }}
          >
            {this.props.title}
          </MDBModalHeader>
          <MDBModalBody style={{ textAlign: "justify" }}>
            {ReactHTMLParser(this.props.bodycontent)}
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn
              onClick={this.props.toggle}
              style={{ backgroundColor: "#3f51b5" }}
            >
              Close
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    );
  }
}

export default AboutModal;
